module.exports = __webpack_public_path__ + "img/imageone.cf98ebdf.jpg";